module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/colorado-4bb076ad1f2c51c8050741a275d6d2e0.jpg";